import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="6.8mm"
    height={22.167}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 34715 29941"
    {...props}
  >
    <path
      d="M33847 29074h-62c-958 0-1736-779-1736-1736v-7811c0-957 778-1736 1736-1736h62v11283zM21688 14320H877c228-5542 4809-9981 10405-9981 5597 0 10177 4439 10406 9981zm-10406 6075c-2964 0-5402-2299-5625-5207h11250c-222 2908-2660 5207-5625 5207zm22999-3472h-496c-1435 0-2604 1168-2604 2604v3471c-2364-33-4277-1966-4277-4339v-7377C26904 5061 21843 0 15622 0h-1302c-1914 0-3472 1557-3472 3471v9C4828 3709 0 8678 0 14754c0 240 194 434 434 434h4354c224 3387 3051 6075 6494 6075 3444 0 6270-2688 6495-6075h4354c240 0 434-194 434-434 0-6076-4828-11045-10849-11274v-9c0-1435 1168-2603 2604-2603h1302c5742 0 10414 4672 10414 10414v7377c0 2851 2302 5174 5145 5207v3472c0 1436 1169 2603 2604 2603h496c240 0 434-194 434-433V17357c0-239-194-434-434-434z"
      style={{
        fill: "#1c1c1d",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
